import React from 'react';
import SubMenu from './SubMenu';

const ContactLens = props => {
  const { menuData, updateNavValueDtm, section, triggerDataLayerOnCtaClick } = props;
  const fetchMenu = menuData.data.map((data, index) => {
    // const subParentKey = data;
    return Object.keys(data).map(key => {
      return (
        <div key={index} className="nav-level-2 cl">
          {section !== 'Kids Glasses' && <div className="line-sep"></div>}
          <SubMenu submenu={data[key]} updateNavValueDtm={updateNavValueDtm} section={section} />
          {section === 'Kids Glasses' && (
            <div className="BannerDiv">
              <a
                onClick={e => triggerDataLayerOnCtaClick(section + ' ' + menuData.imgAlt, e)}
                href={menuData.imgUrl}
              >
                <img
                  className="BannerImgCont img lazy-load-image"
                  src="https://static1.lenskart.com/media/desktop/img/GreyBackground.png"
                  data-src={menuData.img}
                  alt={menuData.imgAlt}
                />
              </a>
            </div>
          )}
        </div>
      );
    });
  });

  return <div className="nav-level-acc big-screen-wrapper contact-lens">{fetchMenu}</div>;
};

export default ContactLens;
